import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "axios";
import store from './store/index';
import Mint from 'mint-ui';
import ElementUI from 'element-ui';
import iView from 'iview';
import 'mint-ui/lib/style.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'iview/dist/styles/iview.css'

Vue.use(Mint);
Vue.use(ElementUI);
Vue.use(iView);
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js